<script>
import { defineComponent } from "vue";
import customerInvoiceItem from '@/components/customer/invoices/invoiceItem.vue';
import EmailInvoiceModal from '@/components/customer/invoices/emailInvoiceModal.vue';
import { useMeta } from 'quasar';

const metaData = {
  // sets document title
  title: 'Windy City Wire - Invoices',
  // optional; sets final title as "Index Page - My Website", useful for multiple level meta
  titleTemplate: title => `${title}`,
}

export default defineComponent({
  name: "customerInvoices",
  setup() {
    useMeta(metaData);
  },
  data() {
      return {
          limit: 25,
          offset: 0,
          height: "",
          stopLoading: false,
          initialRun: true
      }
  },
  components: {
    customerInvoiceItem,
    EmailInvoiceModal,
  },
  computed: {
      accessToken() {
          return this.$store.getters['auth/accessToken'];
      },
      emailQuote() {
          return this.$store.getters['customer/emailQuote'];
      },
      isProcessingOrder() {
          return this.$store.getters['customer/isProcessingOrder'];
      },
      user() {
          return this.$store.getters['auth/user'];
      },
      viewHeight() {
          return this.$store.getters['viewHeight']
      },
      invoices() {
        return this.$store.getters['customer/invoices'];
      }
  },
  methods: {
      fetchInvoices() {
          this.$store.dispatch('customer/getInvoices', [this.accessToken, this.limit, this.offset])
      },
      async onLoad (index, done) {
      
        if (!this.stopLoading) {
            if (index>1) {
              this.offset = this.offset + this.limit;
            }
            //this.offset = this.offset + this.limit;
            this.$store.dispatch('customer/getInvoices', [this.accessToken, this.limit, this.offset]);
            this.stopLoading = true;
            done()
        }
      }
  },
  watch: {
    invoices() {
        if (this.invoices.length==0) {
            this.stopLoading = true;
        }
        
    },
    viewHeight() {
        this.height = (this.viewHeight).toString() + 'px'
    }
  },
});
</script>


<template>
<div style="height: 100%">
    <q-scroll-area ref="scrollTargetRef" v-bind:style="{height: '100vh', maxWidth: '100%', paddingBottom: '50px'}">
        <q-infinite-scroll @load="onLoad" :offset="250" :scroll-target="scrollTargetRef" :debounce="1000">
            <q-list bordered>
                <customer-invoice-item v-for="(q, idx) in invoices" :key="idx" :inv=q></customer-invoice-item>
            </q-list>
        </q-infinite-scroll>

    </q-scroll-area>

      <q-inner-loading
        :showing="isProcessingOrder"
        label="Please wait loading data..."
        label-class="text-cyan-7"
        label-style="font-size: 1.5em"
        color="cyan-7"
      />

      <!-- MODALS -->
      <email-invoice-modal></email-invoice-modal>


  </div>
</template>